export const isProd = window.location.host === "www.digipost.no";
export const isLocalEnvironment = process.env.NODE_ENV !== "production";
